













import { Vue, Component } from 'vue-property-decorator';
import { Button, Dialog, Toast, Popup } from 'vant';
Vue.use(Popup)
  .use(Dialog)
  .use(Toast)
  .use(Button);
@Component
export default class WxPopup extends Vue {
  pointOut = false;
}
